(function ($) {
    $(() => {
        let scrollPos = 0;

        $('.navbar-toggler').on('click', function () {
            $(this).toggleClass('is-active');
            $('.navbar-collapse').toggleClass('is-opened');

            // Fix body if navbar is opened on mobile
            //
            //
            if ($('.navbar-collapse').hasClass('is-opened')) {
                scrollPos = $(window).scrollTop();
                $('body').css({
                    overflow: 'hidden',
                    position: 'relative'
                });
            } else {
                $('body').css({
                    overflow: '',
                    position: 'relative',
                    top: ''
                });
            }
        });
    });

    $(document).mouseup(e => {
        const container = $('.navbar-collapse:before');

        if (!container.is(e.target) && container.has(e.target).length === 0) {
            $('.navbar-collapse').removeClass('is-opened');
            $('.hamburger--collapse').removeClass('is-active');
            $('.hamburger-box span').addClass('hamburger-inner');

            $('body').css({
                overflow: '',
                position: 'relative',
                top: ''
            });
        }
    });

    $('.logo').on('click', () => {
        $('html, body').animate({scrollTop: 0}, 'slow');
    });

    $('.nav-link,.contact_button,.scroll_button').on('click', function (e) {
        e.preventDefault();
        const hash = $(this).prop('hash');
        const scrollTopAnimateTo = $(hash).offset().top - $('#menu').height(); /* * 1/window.devicePixelRatio + $(window).scrollTop() * (1 - 1/window.devicePixelRatio) */
        $('html, body').animate({scrollTop: scrollTopAnimateTo},500);
    });

    $('.close').on('click', () => {
        $('.navbar-collapse').removeClass('is-opened');
        $('.hamburger--collapse').removeClass('is-active');
        $('.hamburger-box span').addClass('hamburger-inner');

        $('body').css({
            overflow: '',
            position: 'relative',
            top: ''
        });
    });
})(jQuery);
